export default __webpack_public_path__ + "static/img-home-coop-careers-e273654a9c530c145c13548b9c44a3dd.jpg";